// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/routes/LightHome";
import { fetchEnableds } from "actions/events/thunks";

const mapStateToProps = ({ events: { needsRefresh } }) => ({
  needsRefresh,
});

const mapDispatchToProps = {
  fetchEnableds,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
